import React from 'react';
import styles from './TopBanner.module.scss';
import { FaGlobe, FaXTwitter, FaFacebookF, FaLinkedinIn } from 'react-icons/fa6';

const TopBanner = () => (
  <header className={styles.banner}>
    <div className={styles.left}>
      PROPRT.io's $5M ICO: Property Investing on the Blockchain
    </div>
    <div className={styles.right}>
      <div className={styles.socials}>
        <a href="https://x.com/Proprt_io" aria-label="Share on X (Twitter)" target="_blank" rel="noopener noreferrer"><FaXTwitter /></a>
        <a href="https://www.facebook.com/web3property" aria-label="Share on Facebook" target="_blank" rel="noopener noreferrer"><FaFacebookF /></a>
        <a href="https://www.linkedin.com/company/proprt-io/" aria-label="Share on LinkedIn" target="_blank" rel="noopener noreferrer"><FaLinkedinIn /></a>
      </div>
      <a
        href="https://proprt.io" // Replace with actual website
        className={styles.websiteBtn}
        target="_blank"
        rel="noopener noreferrer"
      >
        <FaGlobe className={styles.globeIcon} />
        Visit our website
      </a>
    </div>
  </header>
);

export default TopBanner;
